import React, { useRef } from 'react';
import { makeStyles, Tooltip } from '@material-ui/core';

const useToolTipStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.common.white,
    '& > img': {
      marginRight: '8px',
    },
  },
}));

// TODO add props types

export const ToastTooltip = (props: any) => {
  const { open, children, message, icon } = props;
  const nodeRef = useRef(null);
  const classes = useToolTipStyles();

  return (
    <Tooltip
      ref={nodeRef}
      open={open}
      placement={props.placement}
      PopperProps={props.PopperProps}
      title={
        <div className={classes.content}>
          <img src={icon} alt="" />
          <span>{message}</span>
        </div>
      }
    >
      <div ref={nodeRef}>{children}</div>
    </Tooltip>
  );
};
